import {DefaultInteraction} from "./interaction";
import axios from "axios";


export class ApiCallInteraction extends DefaultInteraction {

	interactionData
	metadata = {}

	key() {
		return "api_call"
	}

	runInteraction(interactionData, metadata, onSuccess,onError) {
		console.log("ExternalCallInteraction", interactionData, metadata)
		this.interactionData = interactionData
		this.metadata = metadata

		this._build().then((r) => {
			onSuccess(r.data)
		}).catch((e) => {
			onError(e)
		})

		return false //Success/error called from promise
	}

	_build() {

		console.log("Building interaction", this.interactionData, this.metadata)


		const cfg = {
			method: this.interactionData.method,
			url: this.interactionData.url,
			timeout: 3000,
		}
		this._addBody(cfg)

		if (this.interactionData.headers)
			cfg.headers = this.interactionData.headers

		switch (cfg.method.toLowerCase()) {
			case "get":
				return axios.get(this.interactionData.url, cfg)
			case "post":
				return axios.post(this.interactionData.url, cfg.data, cfg)
			case "put":
				return axios.put(this.interactionData.url, cfg.data, cfg)
			case "delete":
				return axios.delete(this.interactionData.url, cfg)
		}
	}

	_addBody(cfg) {
		const data = Object.assign({}, this.interactionData.body, this.metadata)

		if (cfg.method.toUpperCase() === "GET")
			cfg.params = data
		else
			cfg.data = data
	}
}